import { render, staticRenderFns } from "./action-document-select.vue?vue&type=template&id=f834e1e0"
import script from "./action-document-select.vue?vue&type=script&lang=js"
export * from "./action-document-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports